import { combineReducers } from 'redux';
import { initialState as initialStateProfile } from './reducers/memberProfileReducer';
import memberOverviewReducer, {
  initialState as initialStateOverview,
} from './reducers/memberOverviewReducer';
import memberContactHistoryReducer, {
  initialState as initialContactHistory,
} from './reducers/memberContactHistoryReducer';
import memberTagLineReducer, {
  initialState as initialStateTagLineReducer,
} from './reducers/memberTagLineReducer';
import memberPreviewReducer, {
  initialState as initialStatePreviewReducer,
} from './reducers/memberPreviewReducer';

const initialStateMember = {
  profile: null,
  contactHistory: {},
  overview: {},
  gridColumn: null,
  tagLine: {},
};

export {
  initialStateMember,
  initialStateProfile,
  initialStateOverview,
  initialContactHistory,
  initialStateTagLineReducer,
  initialStatePreviewReducer,
};

export default combineReducers({
  contactHistory: memberContactHistoryReducer,
  overview: memberOverviewReducer,
  tagLine: memberTagLineReducer,
  preview: memberPreviewReducer,
});
